import React, { useState, useEffect } from "react";
import { api } from "./../../../../../services/api";
import "./SendMessageEvolution.css";

const SendMessageEvolutionConfig = ({ config, onChange, validationErrors }) => {
  const [localConfig, setLocalConfig] = useState({
    id_workspace_integration: config?.id_workspace_integration || null,
    phone: config?.phone || "",
    content: config?.content || "",
    apply_anti_block: config?.apply_anti_block !== undefined ? config.apply_anti_block : true,
    force_send: config?.force_send || false,
  });

  const [integrations, setIntegrations] = useState([]);

  useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const response = await api.get("/api/integrations");

        const integrationsList = Array.isArray(response.data) ? response.data : [];

        const filtered = integrationsList.filter(
          (integration) =>
            integration.key === "whatsapp_evolution" && integration.status === "connected"
        );

        setIntegrations(filtered);

        if (!localConfig.id_workspace_integration && filtered.length > 0) {
          const newConfig = { ...localConfig, id_workspace_integration: filtered[0].id };
          setLocalConfig(newConfig);
          onChange(newConfig);
        }
      } catch (error) {
        console.error("Error fetching integrations:", error);
        setIntegrations([]); // garante estado consistente
      }
    };

    fetchIntegrations();
  }, []); // mantém como você pediu (sem mudar arquitetura)

  const updateConfig = (field, value) => {
    const newConfig = { ...localConfig, [field]: value };
    setLocalConfig(newConfig);
    onChange(newConfig);
  };

  return (
    <div className="evolution-config">
      <h3>Evolution - Send Message</h3>

      <div className="field">
        <label>Integração WhatsApp *</label>
        <select
          value={localConfig.id_workspace_integration ?? ""}
          onChange={(e) => {
            const rawValue = e.target.value;
            const parsedValue = rawValue ? Number(rawValue) : null;
            updateConfig("id_workspace_integration", parsedValue);
          }}
        >
          <option value="">Selecione uma integração</option>
          {integrations.map((integration) => (
            <option key={integration.id} value={integration.id}>
              {integration.label}
            </option>
          ))}
        </select>

        {validationErrors?.id_workspace_integration && (
          <span className="error">{validationErrors.id_workspace_integration}</span>
        )}
      </div>

      <div className="field">
        <label>Telefone *</label>
        <input
          type="text"
          value={localConfig.phone}
          onChange={(e) => updateConfig("phone", e.target.value)}
          placeholder="5511999999999"
        />
        <small>Digite o número com código do país e DDD (sem espaços ou caracteres especiais)</small>
        {validationErrors?.phone && <span className="error">{validationErrors.phone}</span>}
      </div>

      <div className="field">
        <label>Mensagem *</label>
        <textarea
          value={localConfig.content}
          onChange={(e) => updateConfig("content", e.target.value)}
          placeholder="Olá, tudo bem? Segue a proposta conforme combinado!"
          rows={4}
        />
        {validationErrors?.content && <span className="error">{validationErrors.content}</span>}
      </div>

      <div className="field">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={localConfig.apply_anti_block}
            onChange={(e) => updateConfig("apply_anti_block", e.target.checked)}
          />
          <span>Aplicar proteção anti-bloqueio</span>
        </label>
        <small>Adiciona variações de tempo e formatação para evitar bloqueios</small>
      </div>

      <div className="field">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={localConfig.force_send}
            onChange={(e) => updateConfig("force_send", e.target.checked)}
          />
          <span>Forçar envio</span>
        </label>
        <small>Envia mensagem mesmo se houver erros de validação</small>
      </div>
    </div>
  );
};

export default SendMessageEvolutionConfig;
